<mat-card class="ticket-card">

    <!-- BASIC INFO -->
    <h3 class="section-title">Basic Information</h3>
    <div class="grid grid-3">
        <mat-form-field appearance="outline">
            <mat-label>Category Name</mat-label>
            <input matInput [(ngModel)]="category" placeholder="VIP / Gold / Silver" required #cat="ngModel">
            <mat-error *ngIf="cat.invalid && cat.touched">Category is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Color Code</mat-label>
            <input matInput [(ngModel)]="color" placeholder="#FFD700">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Auto Assign</mat-label>
            <mat-error *ngIf="auto.invalid && auto.touched">
                Auto assign selection required
            </mat-error>
            <mat-select [(ngModel)]="auto_assign" required #auto="ngModel">
                <mat-option value="yes">Yes</mat-option>
                <mat-option value="no">No</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!-- PRICING -->
    <h3 class="section-title">Pricing</h3>
    <div class="grid grid-3">

        <!-- Ticket Amount -->
        <mat-form-field appearance="outline">
            <mat-label>Ticket Amount</mat-label>
            <input type="number" matInput [(ngModel)]="ticket_amount" required #amt="ngModel"
                (focus)="clearZero('ticket_amount')" (ngModelChange)="calculateTotals()">

            <mat-error *ngIf="amt.invalid && amt.touched">
                Ticket amount is required
            </mat-error>
        </mat-form-field>

        <!-- Convenience Type -->
        <mat-form-field appearance="outline">
            <mat-label>Convenience Type</mat-label>
            <mat-select [(ngModel)]="convenience_type" (selectionChange)="calculateTotals()"
                [required]="convenience_fee > 0">
                <mat-option value="flat">Flat</mat-option>
                <mat-option value="percentage">Percentage</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Convenience Fee Input -->
        <mat-form-field appearance="outline">
            <mat-label>
                Convenience Fee
                <span *ngIf="convenience_type === 'percentage'">(%)</span>
            </mat-label>

            <input type="number" matInput [(ngModel)]="convenience_fee" min="0" [disabled]="!convenience_type"
                #conv="ngModel" (focus)="clearZero('convenience_fee')" (blur)="restoreZero('convenience_fee')"
                (ngModelChange)="calculateTotals()">

            <mat-hint *ngIf="convenience_type === 'percentage'">
                Calculated on ticket amount
            </mat-hint>

            <mat-error *ngIf="conv.invalid && conv.touched">
                Convenience fee required
            </mat-error>
        </mat-form-field>

        <!-- Total Convenience (CALCULATED) -->
        <mat-form-field appearance="outline">
            <mat-label>Total Convenience</mat-label>
            <input type="number" matInput [(ngModel)]="total_convenience_fee" readonly>
        </mat-form-field>

    </div>


    <!-- TAX -->
    <h3 class="section-title">GST Details</h3>
    <div class="grid grid-4">
        <mat-form-field appearance="outline">
            <mat-label>CGST %</mat-label>
            <input type="number" matInput [(ngModel)]="cgst_per" min="0" max="100" (focus)="clearZero('cgst_per')"
                (blur)="restoreZero('cgst_per')" (ngModelChange)="calculateTotals()">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>SGST %</mat-label>
            <input type="number" matInput [(ngModel)]="sgst_per" min="0" max="100" (focus)="clearZero('sgst_per')"
                (blur)="restoreZero('sgst_per')" (ngModelChange)="calculateTotals()">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>IGST %</mat-label>
            <input type="number" [disabled]="cgst_per > 0 || sgst_per > 0" matInput (focus)="clearZero('igst_per')"
                (blur)="restoreZero('igst_per')" [(ngModel)]="igst_per" min="0" max="100"
                (ngModelChange)="calculateTotals()">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Other Charges</mat-label>
            <input type="number" matInput [(ngModel)]="other_charges" (focus)="clearZero('other_charges')"
                (blur)="restoreZero('other_charges')" (ngModelChange)="calculateTotals()">
        </mat-form-field>
    </div>

    <!-- TOTALS -->
    <div class="grid grid-3 readonly-box">
        <mat-form-field appearance="outline">
            <mat-label>Total Charges</mat-label>
            <input matInput [(ngModel)]="total_charges" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Total Amount</mat-label>
            <input matInput [(ngModel)]="total_amount" readonly>
        </mat-form-field>
    </div>

    <!-- RULES -->
    <h3 class="section-title">Ticket Rules</h3>
    <div class="grid grid-3">
        <mat-form-field appearance="outline">
            <mat-label>Total Tickets</mat-label>
            <input type="number" matInput [(ngModel)]="total_category_tickets" required min="1" #tot="ngModel">
            <mat-error *ngIf="tot.invalid && tot.touched">
                Total tickets required
            </mat-error>

        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Max Buying Ticket Quantity Allowed Per User</mat-label>
            <input type="number" matInput [(ngModel)]="max_allowed">
        </mat-form-field>
    </div>

    <mat-divider></mat-divider>

    <!-- SETUP -->
    <div class="ticket-heading">
        <span>Ticket Setup</span>
        <button mat-stroked-button color="primary" (click)="addTicketSetup()">
            <mat-icon>add</mat-icon> Add Row
        </button>
    </div>

    <div class="ticket-setup-container" *ngIf="!category_id">
        <div class="ticket-row" *ngFor="let ticket of ticketSetupList; let i = index">
            <mat-form-field appearance="outline">
                <mat-label>Row</mat-label>
                <input matInput [(ngModel)]="ticket.row">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>No. of Tickets</mat-label>
                <input type="number" matInput [(ngModel)]="ticket.no_of_tickets">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Start From</mat-label>
                <input type="number" matInput [(ngModel)]="ticket.start_from">
            </mat-form-field>

            <button mat-icon-button color="warn" *ngIf="ticketSetupList.length > 1" (click)="removeTicketSetup(i)"
                matTooltip="Delete">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>


</mat-card>
<mat-card-actions align="end">
    <button mat-raised-button (click)="Update_Setting()">
        <mat-icon>save</mat-icon>
        Save Changes
    </button>
</mat-card-actions>